module.exports = __webpack_public_path__ + "img/47f88313d6ad57bdd05b594a2e02b137.7d9c0715.png";